import { Link } from '@chakra-ui/next-js';
import { Box, Flex, Text } from '@chakra-ui/react';
import { render } from 'datocms-structured-text-to-html-string';
import { useLayoutEffect, useRef, useState } from 'react';

/* Internal Imports */
/* Components */
import StructuredTextParser from '@app-ila/components/Utility/StructuredTextParser';
import LazyLoadImageComponent from '@components/UI/LazyLoadImageComponent';

/**
 *
 * @param {Object} postData
 * @returns
 */
const PopUpCard = ({ postData }) => {
  const ref = useRef(null);
  const [height, setHeight] = useState(0);
  const [clientHeight, setClientHeight] = useState(0);
  const [opts, setOpts] = useState({});

  useLayoutEffect(() => {
    setHeight(ref.current.scrollHeight);
    setClientHeight(ref.current.clientHeight);
  }, []);

  return (
    <Flex
      flexDir={{ base: 'column', md: 'row' }}
      justifyContent="space-between"
    >
      <Box display="flex" className="Individual container">
        <Box width={{ base: '100%' }} pos="relative">
          {postData?.tagType && (
            <Box
              pos="absolute"
              bottom={{ base: '20px', md: '50px' }}
              display={{ base: 'block', md: 'block' }}
              right={0}
              width="auto"
              padding="5px"
              minW={171}
              height={33}
              background={
                postData?.tagType?.toLowerCase()?.trim() == 'filling fast'
                  ? '#FF0000'
                  : '#D8A24C'
              }
            >
              <Text
                color="#fff"
                textAlign="center"
                fontFamily="var(--FedraSansCondensedMedium), sans-serif"
                fontSize="16px"
                fontStyle="normal"
                fontWeight="500"
                lineHeight="24px"
                textTransform="uppercase"
              >
                {postData?.tagType}
              </Text>
            </Box>
          )}
          <LazyLoadImageComponent
            alt={postData?.image?.alt}
            src={postData.image_src || postData?.image?.url}
            w={{ base: '100%', md: '355px' }}
            h={{ base: 'auto', md: '447.16px' }}
            objectFit={{ base: 'unset', md: 'cover' }}
            mx="auto"
          />
        </Box>
      </Box>
      <Box
        maxW={700}
        ml={{ base: '0px', md: '40px' }}
        mt={{ base: '30px', md: '0' }}
        position="relative"
      >
        <Flex
          alignItems={{ base: 'flex-start', md: 'center' }}
          flexDir={{ base: 'column', md: 'row' }}
        >
          <Text
            fontFamily="var(--FedraSansStd-medium), sans-serif"
            fontStyle="normal"
            letterSpacing="-0.098px"
            fontWeight={500}
            color="#210303"
            fontSize="32px"
            lineHeight={{ base: '22.495px', md: '27.139px' }}
            mb="10px"
            borderBottom="4px solid white"
            _hover={{
              borderBottom: '4px solid black',
            }}
            // mt={{ base: '30px', md: '30px' }}
          >
            <Link
              href={postData?.profileLink}
              target="_blank"
              style={{
                display: 'flex',
                alignItems: 'flex-end',
                justifyContent: 'space-between',
                columnGap: '10px',
                paddingBottom: '3px',
              }}
              _hover={{
                textDecor: 'none',
              }}
            >
              <Box p={{ base: '0 0 5px 0', md: '0' }}>{postData?.title} </Box>
              {postData?.profileLink && (
                <LazyLoadImageComponent
                  src="https://static.sadhguru.org/d/46272/1747313233-vector.png"
                  w="24px"
                  mb="3px"
                />
              )}
            </Link>
          </Text>

          <Box
            width="2px"
            height="66px"
            bg="#F27123"
            ml="27px"
            mr="30px"
            display={{ base: 'none', md: 'block' }}
          ></Box>

          <Text
            color="#210303"
            maxW={{ base: '100%', md: '348.931px' }}
            lineHeight={{ base: '20px', md: '24px' }}
            fontSize="16px"
            // mt={{ base: '1px', md: '5px' }}
            fontWeight={400}
            fontStyle="italic"
            pb={{ base: '24px' }}
          >
            {postData?.designation}
          </Text>
        </Flex>
        <Box
          maxH={{ base: '130px', md: '390px' }}
          pb="30px"
          className="scrollbar"
          ref={ref}
        >
          <StructuredTextParser
            color="#5E5E5E"
            mt={{ base: '12px', md: '37px' }}
            lineHeight={{ base: '24px', md: '32px' }}
            fontSize={{ base: '16px', md: '18px' }}
            str={render(postData?.description)}
            pb="70px"
          />
        </Box>
        {/* {
          clientHeight < height ?

          (
            <Box display={{base:'none', lg:'flex'}} justifyContent="center" bgGradient="linear-gradient(0deg, rgba(255,255,255,1) 20%, rgba(255,255,255,0) 100%)" height="90px" position="absolute" bottom="0px" w="full">
            <Box display="flex" alignItems="end" h="full">
            <svg width="32" height="19" viewBox="0 0 32 19" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M2 2L16 16L30 2" stroke="#848484" stroke-width="4"/>
            </svg>
            </Box>
          </Box>
          ) : null
        } */}
      </Box>
      <style jsx global>
        {`
          .scrollbar {
            overflow-y: auto;
            padding-right: 20px;
          }

          .scrollbar::-webkit-scrollbar {
            width: 12px;
          }

          .scrollbar::-webkit-scrollbar-track {
            background: #e4e4e4;
          }

          .scrollbar::-webkit-scrollbar-thumb {
            background: #f27123;
          }

          .scrollbar ::-webkit-scrollbar-thumb:hover {
            background: #e4e4e4;
          }
          @media (max-width: 767px) {
            .scrollbar {
              overflow-y: unset;
            }
          }
        `}
      </style>
    </Flex>
  );
};

export default PopUpCard;
